import React, { useEffect, useState } from "react";
import "../App.css";

const HomePage = () => {
  const [animationStarted, setAnimationStarted] = useState(false);

  useEffect(() => {
    setAnimationStarted(true);
  }, []);

  return (
    <main>
      <section className="hero-main">
        <div className="hero-content">
          <h1 className="hero-title">Apps & Sites Built for Real People</h1>
          <p className="hero-subtitle">
            We’re a small team in NYC building things that work, look good, and
            help you grow. No jargon. No drama. Just solid results.
          </p>
          <a href="#contact" className="cta-btn hero-cta">
            Let’s Chat
          </a>
        </div>
        <div className="hero-image">
          <img src="/jumbo.png" alt="Our team at work" />
        </div>
      </section>
      <section className="services-section">
        <h2 className="section-title">What We Actually Do</h2>
        <div className="services-grid">
          <div className="service-card">
            <img src="/app-development.png" alt="App Development" />
            <h3>App Development</h3>
            <p>
              We build apps that don’t break. Fast, reliable, and easy to use,
              whether you’re a startup or a local business.
            </p>
          </div>
          <div className="service-card">
            <img src="/site-images/site-image-2.jpg" alt="Web Design" />
            <h3>Web Design</h3>
            <p>
              Clean, modern websites that look great on any device. We keep it
              simple and focused on your goals.
            </p>
          </div>
          <div className="service-card">
            <img src="/site-images/site-image-1.jpg" alt="Consulting" />
            <h3>Consulting</h3>
            <p>
              Not sure what you need? We’ll help you figure it out, no pressure
              and no upsell.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
